<template>
  <row>
    <col4 style="cursor: pointer" @click="toggleDetails">
      <row>
        <col1>
            <i v-if="!job.processing && !job.processed" class="fas fa-hourglass-start"></i>
            <i v-if="job.processing && !job.processed" class="fas fa-spinner fa-spin"></i>
        </col1>
        <col11>
            {{ message }} - {{job.created_at}} <br />
            <span v-if="job.processed && description.filepath && typeof description.filename !== 'undefined'">{{description.summary}} (<a :href="description.filepath + description.filename">Download</a>)</span>
            <v-chip v-if="job.processed===0 && description.state && typeof description.state !== 'undefined'">{{description.state}}</v-chip>
        </col11>
      </row>
    </col4>
    <col4>
      <v-progress-linear
          :value="job.progress"
          height="20"
          rounded
        >
          <strong>{{ Math.ceil(job.progress) }}%</strong>
        </v-progress-linear>
    </col4>
    <col8 v-if="toggled">
      <div class="job-details">
        <div v-if="filterCriteria.length > 0" class="job-details__filters mb-2">
          <div class="text-overline mb-1">{{ $t('auto_t.filter_title') }}</div>
          <ul class="job-details__filter-list mb-0">
            <li v-for="(criterion, index) in filterCriteria" :key="index">
              <span class="font-weight-medium">{{ criterion.label }}:</span>
              {{ criterion.value }}
            </li>
          </ul>
        </div>
        <div v-if="description.log" class="mb-1">{{ description.log }}</div>
        <div class="text-caption text-medium-emphasis">Job id: {{ job.id }}</div>
      </div>
    </col8>
  </row>
</template>

<script>
import Col4 from "@/components/layout/Col4";
import Col8 from "@/components/layout/Col8";
import Col1 from "@/components/layout/Col1";
import Row from "@/components/layout/Row";
import Col11 from "@/components/layout/Col11";
import { formatFilterCriteria } from "@/components/myboxes/relabelInFilterJobUtils";
import { assetFilterFromJobDescription } from "@/components/auto/noDuplicatesJobUtils";

export default {
  name: "Job",
  components: {Col11, Col8, Col4, Col1, Row},
  props: {
    'job': {required: true},
    'message': {default: ''},
  },
  data() {
    return {
      'toggled': false,
      filterOptions: [],
    }
  },
  computed: {
    'description' () {
      if(this.job.description === '') {
        return {}
      }
      try {
        return JSON.parse(this.job.description)
      }
      catch (error) {
        return {}
      }
    },
    filterCriteria() {
      const filters = assetFilterFromJobDescription(this.description);
      const flatLen = Array.isArray(filters)
        ? filters.length
        : (filters && filters.groups ? filters.groups.reduce((n, g) => n + g.length, 0) : 0);
      if (flatLen === 0 && this.description.filters != null) {
        return formatFilterCriteria(this.description.filters, this.filterOptions);
      }
      return formatFilterCriteria(filters, this.filterOptions);
    },
  },
  methods: {
    async toggleDetails() {
      this.toggled = !this.toggled;
      if (this.toggled && this.filterOptions.length === 0) {
        await this.loadFilterOptions();
      }
    },
    async loadFilterOptions() {
      try {
        this.filterOptions = await this.$api.asset.filter_options();
      } catch (error) {
        console.error('Failed to load filter options', error);
        this.filterOptions = [];
      }
    },
  },
}
</script>

<style scoped>
.job-details__filter-list {
  padding-left: 18px;
}
</style>
